/*! js-cookie v3.0.0-rc.4 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,r=e.Cookies=t();r.noConflict=function(){return e.Cookies=n,r}}())}(this,function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}var t={read:function(e){return e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}};return function n(r,o){function i(t,n,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape),n=r.write(n,t);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n+c}}return Object.create({set:i,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],o={},i=0;i<n.length;i++){var c=n[i].split("="),u=c.slice(1).join("=");'"'===u[0]&&(u=u.slice(1,-1));try{var f=t.read(c[0]);if(o[f]=r.read(u,f),e===f)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){i(t,"",e({},n,{expires:-1}))},withAttributes:function(t){return n(this.converter,e({},this.attributes,t))},withConverter:function(t){return n(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(r)}})}(t,{path:"/"})});

document.addEventListener('DOMContentLoaded', function() {

    // Select your vehicle dropdown
    let addYourVehicleElements = document.querySelectorAll('.select-your-vehicle');
    addYourVehicleElements.forEach(function(addYourVehicle) {
        let addYourVehicleLabel = addYourVehicle.querySelector('label');
        let addYourVehicleOption = addYourVehicle.querySelectorAll('[data-vehicle]');
        let addYourVehicleText = addYourVehicle.querySelector('.label-text');
        let removeSelectedVehicleModel = addYourVehicle.querySelector('.remove-selected-vehicle-model');
        let timeout = addYourVehicle.classList.contains('select-your-vehicle--mobile') ? 500 : 0;

        if (Cookies.get('user_vehicle')) {
            addYourVehicleText.innerHTML = Cookies.get('user_vehicle').replace('2024', '2026');;
            if (removeSelectedVehicleModel) {
                removeSelectedVehicleModel.style.display = 'block';
            }
        }

        addYourVehicleOption.forEach(function(item) {
            let vehicle = item.getAttribute('data-vehicle');
            item.addEventListener('click', function() {
                addYourVehicleText.innerHTML = vehicle;
                Cookies.set('user_vehicle', vehicle, { expires: 30 });
                setTimeout(function() {
                    window.location.href = window.location.origin + window.location.pathname;
                }, timeout);
            });
        });

        // Remove selected vehicle model
        if (removeSelectedVehicleModel) {
            removeSelectedVehicleModel.addEventListener('click', function() {
                Cookies.remove('user_vehicle');
                addYourVehicleText.innerHTML = 'Add your vehicle';
                setTimeout(function() {
                    location.reload();
                }, timeout);
            });
        }
    });

    // Toggle visibility of the dropdown on mobile
    let mobileDropdown = document.querySelector('.select-your-vehicle--mobile');
    if (mobileDropdown) {
        mobileDropdown.addEventListener('click', function(event) {
            let dropdownList = mobileDropdown.querySelector('ul');

            if (dropdownList && !dropdownList.contains(event.target)) {
                if (dropdownList.style.display === 'block') {
                    dropdownList.style.display = 'none';
                } else {
                    dropdownList.style.display = 'block';
                }
            }
        });

        document.addEventListener('click', function(event) {
            if (!mobileDropdown.contains(event.target)) {
                let dropdownList = mobileDropdown.querySelector('ul');
                if (dropdownList) {
                    dropdownList.style.display = 'none';
                }
            }
        });
    }

    // Auto select vehicle model variant
    if (Cookies.get('user_vehicle')) {

        let selectedVehicle = Cookies.get('user_vehicle').replace('2024', '2026');
        let vehicleModelNote = document.querySelectorAll('.vehicle-model-note');
        let vehicleModelNoteText = document.querySelectorAll('.vehicle-model-note__text');
        let productList = document.querySelector('.product__list');
        let pdpProductList = document.querySelectorAll('.pdp-collection');
        let collectionList = document.querySelector('.collection__list');
        let selectedVehicleSlug = 'show-model--'+selectedVehicle.toLowerCase().replace(/ - /g, '-').replace(/\s+/g, '-');
        let addYourVehicleModalTrigger = document.querySelectorAll('.add-your-vehicle-modal-trigger');

        if(addYourVehicleModalTrigger){
            addYourVehicleModalTrigger.forEach(function(trigger) {
                trigger.style.display = 'none';
            });
        }

        // collections list
        if(collectionList){
            collectionList.classList.add('show-compatible-products');
            collectionList.classList.add(selectedVehicleSlug);
        }        
    
        if (vehicleModelNote.length && vehicleModelNoteText.length) {

            if(compatibleVehicles.length > 0){

                if (compatibleVehicles.includes(selectedVehicle)) {

                    vehicleModelNoteText.forEach(function(noteText) {
                        noteText.innerHTML = `Fits Your ${selectedVehicle}`;
                    });

                    vehicleModelNote.forEach(function(note) {
                        note.classList.add('green');
                        note.classList.remove('red');
                        note.style.display = 'flex';
                    });
                    
                    let selectedVehicleSlug = 'show-model--'+selectedVehicle.toLowerCase().replace(/ - /g, '-').replace(/\s+/g, '-');

                    // collection page product list
                    if(productList){
                        productList.classList.add('show-compatible-products');
                        productList.classList.add(selectedVehicleSlug);
                    }

                    // pdp product list
                    if (pdpProductList && pdpProductList.length) {
                        pdpProductList.forEach(function(pdpList) {
                            pdpList.classList.add('show-compatible-products');
                            pdpList.classList.add(selectedVehicleSlug);
                        });
                    }

                } else {
                    
                    vehicleModelNoteText.forEach(function(noteText) {
                        noteText.innerHTML = `Does Not Fit Your ${selectedVehicle}`;
                    });

                    vehicleModelNote.forEach(function(note) {
                        note.classList.add('red');
                        note.classList.remove('green');
                        note.style.display = 'flex';
                    });

                    // collection page product list
                    if(productList){
                        productList.style.display = 'none';

                        let collectionHeader = document.querySelector('.collection-heading');
                        let collectionFilter = document.querySelector('.product__list--filter');

                        if (collectionHeader) {
                            collectionHeader.insertAdjacentHTML('afterend', `<div class="no-products-note"><h3>There are no products that fit your ${selectedVehicle}</h3></div>`);
                        }

                        if(collectionFilter) {
                            collectionFilter.style.display = 'none';
                        }
                    }    
                }
            }
        }

        // hide model variant when auto selected
        let selectedVehicleVariantOption = document.querySelector('.product__row--default .product__swatches [data-swatch-option="' + selectedVehicle + '"]');
        if(selectedVehicleVariantOption) {
            let swatchesHolder = selectedVehicleVariantOption.closest('.swatches__holder');

            if (!selectedVehicleVariantOption.classList.contains('swatch--active')) {
                selectedVehicleVariantOption.click();
            }

            if (swatchesHolder) {
                swatchesHolder.style.display = 'none';
            }
        }
    }
});